import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';
import Navbar from './components/Navbar';
import Floating from './components/Floating';
import Home from './pages/Home';
import ServicesPage from './pages/ServicesPage';
import ProjectsPage from './pages/ProjectsPage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import CookieConsent from './components/CookieConsent';
import InteractiveBackground from './components/InteractiveBackground';
import { HelmetProvider } from 'react-helmet-async';

const App = () => {
  const [language] = useState('pl'); // Currently strictly PL based on content.json preference, but structure allows expansion.
  const [years, setYears] = useState(0);

  useEffect(() => {
    const startYear = 2020;
    const currentYear = new Date().getFullYear();
    setYears(currentYear - startYear);
  }, []);

  return (
    <HelmetProvider>
      <Router>
        <div className="min-h-screen flex flex-col relative overflow-hidden">
          <InteractiveBackground />
          <Navbar />
          <Floating />
          <CookieConsent />
          <main className="flex-grow">
            <Routes>
              <Route path="/" element={<Home language={language} years={years} />} />
              <Route path="/uslugi" element={<ServicesPage language={language} />} />
              <Route path="/projekty" element={<ProjectsPage language={language} />} />
              <Route path="/o-mnie" element={<AboutPage language={language} years={years} />} />
              <Route path="/kontakt" element={<ContactPage language={language} />} />
              <Route path="/polityka-prywatnosci" element={<PrivacyPolicyPage />} />
            </Routes>
          </main>
          <footer className="bg-black/80 text-center py-6 text-gray-400 text-sm border-t border-white/10">
            <div className="container mx-auto px-4">
              <p className="mb-2">&copy; {new Date().getFullYear()} Kamil Priefer. Wszelkie prawa zastrzeżone.</p>
              <Link to="/polityka-prywatnosci" className="hover:text-blue-400 transition-colors">
                Polityka Prywatności
              </Link>
            </div>
          </footer>
        </div>
      </Router>
    </HelmetProvider>
  );
};

export default App;
